import Vue from 'vue'
import VueRouter from 'vue-router'
// import PCWearMarket from '../components/PCWearMarket.vue'
import MobileWearMarket from '../views/phone/MobileWearMarket.vue'
import WearMarket from '../components/WearMarket.vue'
import MobileActivity from '../views/phone/components/MobileActivity.vue'
import { isMobile } from '../utils/device'

Vue.use(VueRouter)

// 只在路由配置前判断一次
const WearMarketComponent = isMobile() ? MobileWearMarket : WearMarket
// const WearMarketComponent = WearMarket

const routes = [
  {
    path: '/',
    name: 'Home',
    component: WearMarketComponent,
    props: true
  },
  {
    path: '/activity',
    name: 'Activity',
    component: MobileActivity,
    props: true
  },
  {
    path: '/apps/:type',
    name: 'Apps',
    component: WearMarketComponent,
    props: true
  },
  {
    path: '/dial/:type',
    name: 'Dial',
    component: WearMarketComponent,
    props: true
  },
  {
    path: '/device/:type',
    name: 'Device',
    component: WearMarketComponent,
    props: true
  },
  {
    path: '/platform/:type',
    name: 'Platform',
    component: WearMarketComponent,
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router 